import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import StationeryStockCountEditView from 'src/sections/stationery-stock-count/view/stationery-stock-count-edit-view';

export default function StationeryStockCountEditPage() {
  const { user: authUser } = useAuthContext();

  const params = useParams();

  const { id } = params;

  return (
    <>
      <Helmet>
        <title> Edit stationery stock count</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <StationeryStockCountEditView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
